<div>
    <div *ngIf="allPartialResto.length == 0" style="display: flex;flex-direction:column;align-items:center">
        <img src="../../../assets/img/no_task_found_illustration-v1.svg" alt="" style="width: 37vw;">
        <h1 style="margin-top: 20px;margin-right: 6vw;">No Pending Task</h1>
    </div>

    <div *ngIf="allPartialResto.length > 0">
        <div class="container-head">
            <span class="noOfRestoList">{{allPartialResto.length}} Restaurants</span>
            <span class="resto-input">
                <div style="padding: 2px">
                    <img src="../../../assets/images/Search.png" alt="" />
                    <input placeholder="Restaurant name or ID" [(ngModel)]="searchText" (ngModelChange)="filter()" />
                </div>
            </span>
        </div>


        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 demo-table">
            <!-- Position Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                    SL No.
                </th>
                <td mat-cell *matCellDef="let element; let i = index" class="table-element">
                    {{ i + 1 }}
                </td>
            </ng-container>

            <!-- Resto Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                    Restaurants Name
                </th>
                <td mat-cell *matCellDef="let element" class="table-element">
                    {{ element.resto_name }}
                </td>
            </ng-container>

            <!-- Resto Email Column -->
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef class="table-head checking" style="text-align: center;">
                    Restaurants Email
                </th>
                <td mat-cell *matCellDef="let element" class="table-element" style="text-align: center;">
                    {{element.email}}
                </td>
            </ng-container>

            <!-- Resto Partial Link Column -->
            <ng-container matColumnDef="link">
                <th mat-header-cell *matHeaderCellDef class="table-head checking" style="text-align: center;">
                    Copy Link
                </th>
                <td mat-cell *matCellDef="let element" class="table-element" style="text-align: center;">
                    <span
                        matTooltip="{{ element.tooltipText }}"
                        matTooltipShowDelay="0"
                        matTooltipHideDelay="500"
                        #tooltip="matTooltip"
                        (mouseover)="resetTooltip(element)"
                        >
                        <img
                            src="../../../assets/img/copy-svgrepo-com.svg"
                            alt="Copy"
                            style="width: 25px; cursor: pointer;"
                            (click)="copyToClipboard(element, tooltip)"
                        />
                    </span>
                </td>
            </ng-container>

            <!-- Send Email Column -->
            <ng-container matColumnDef="sendEmail">
                <th mat-header-cell *matHeaderCellDef class="table-head checking" style="text-align: center;">
                    Send Email
                </th>
                <td mat-cell *matCellDef="let element" class="table-element" style="text-align: center;">
                    <img src="../../../assets/img/mail-all-svgrepo-com.svg" alt=""
                        style="width: 25px; cursor: pointer;" (click)="sendEmail(element)">
                </td>
            </ng-container>

            <!-- Delete Column -->
            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef class="table-head checking" style="text-align: center;">
                    Delete
                </th>
                <td mat-cell *matCellDef="let element" class="table-element" style="text-align: center;">
                    <img src="../../../assets/images/deletIcon.png" alt=""
                        style="cursor: pointer;" (click)="deleteResto(element)">
                </td>
            </ng-container>



            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator #paginator1 [pageSizeOptions]="[12, 20, 25]" showFirstLastButtons></mat-paginator>
    </div>
</div>